import { render, staticRenderFns } from "./sfc-college-savings-questions-modal.vue?vue&type=template&id=a8b8f03a&scoped=true&lang=pug&"
import script from "./sfc-college-savings-questions-modal.vue?vue&type=script&lang=js&"
export * from "./sfc-college-savings-questions-modal.vue?vue&type=script&lang=js&"
import style0 from "./sfc-college-savings-questions-modal.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-college-savings-questions-modal.vue?vue&type=style&index=1&id=a8b8f03a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b8f03a",
  null
  
)

export default component.exports